module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "by-the-seaside"
    }
  }, [_c('h2', [_vm._v("By the Seaside")]), _vm._v(" "), _c('p', [_vm._v("We stood along the shore,")]), _vm._v(" "), _c('p', [_vm._v("Savouring the lingering scent of salt water")]), _vm._v(" "), _c('p', [_vm._v("As gentle breezes floated by.")]), _vm._v(" "), _c('p', [_vm._v("You tucked your hand beneath my chin")]), _vm._v(" "), _c('p', [_vm._v("And leaned in for a tender kiss.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("You tasted of Marlboro cigarettes.")]), _vm._v(" "), _c('p', [_vm._v("I smiled in spite of myself,")]), _vm._v(" "), _c('p', [_vm._v("Feeling as if I were back in high school,")]), _vm._v(" "), _c('p', [_vm._v("Skipping class to kiss a boy on the beach of Arcachon.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd355748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0007.vue
// module id = 99
// module chunks = 0